import { Component } from 'react';
import { GroupControl } from '../../../../GroupField';
import MakeField from '../Field';
import MakeControl from '../Control';

export default class MakeGroupField extends Component {
  render() {
    return (
      <MakeField
        {...this.props}
        component={GroupControl}
        FormControl={MakeControl}
      />
    );
  }
}
